const groupSchedules = (schedules = []) => {
  const dayOrder = (code) => {
    if (code >= 1 && code <= 5) return code - 1;
    if (code === 0) return 5;
    if (code === 6) return 6;
    return 7;
  };
  const byDay = new globalThis.Map();

  schedules.forEach((schedule) => {
    const hourFrom = (schedule.hour_from || '').substring(0, 5);
    const hourTo = (schedule.hour_to || '').substring(0, 5);
    const parsedDayCode = schedule.day_code == null ? NaN : Number(schedule.day_code);
    const dayCode = Number.isFinite(parsedDayCode) ? parsedDayCode : null;
    const description = schedule.day_description || '';
    const key = dayCode === null ? `label-${description}` : `code-${dayCode}`;
    const day = byDay.get(key) || { code: dayCode, description, intervals: [] };
    const interval = { hourFrom, hourTo };

    if (!day.intervals.some((item) => item.hourFrom === hourFrom && item.hourTo === hourTo)) {
      day.intervals.push(interval);
    }
    byDay.set(key, day);
  });

  const bySchedule = new globalThis.Map();
  [...byDay.values()].forEach((day) => {
    day.intervals.sort((a, b) => a.hourFrom.localeCompare(b.hourFrom));
    const key = JSON.stringify(day.intervals);
    const schedule = bySchedule.get(key) || { intervals: day.intervals, days: [] };
    schedule.days.push({ code: day.code, description: day.description });
    bySchedule.set(key, schedule);
  });

  const groupedSchedules = [...bySchedule.values()].map(({ intervals, days }) => {
    days.sort((a, b) => {
      const orderDifference = dayOrder(a.code) - dayOrder(b.code);
      return orderDifference || a.description.localeCompare(b.description);
    });
    const everyDay =
      days.length === 7 && new globalThis.Set(days.map((day) => day.code)).size === 7;
    const ranges = [];

    days.forEach((day) => {
      const previousRange = ranges[ranges.length - 1];
      const previousDay = previousRange?.[previousRange.length - 1];
      const isWeekday = day.code >= 1 && day.code <= 5;
      const previousIsWeekday = previousDay?.code >= 1 && previousDay.code <= 5;
      if (isWeekday && previousIsWeekday && day.code === previousDay.code + 1) {
        previousRange.push(day);
      } else {
        ranges.push([day]);
      }
    });

    const dayDescription = everyDay
      ? 'Todos los días'
      : ranges
          .map((range) =>
            range.length > 1
              ? `${range[0].description} a ${range[range.length - 1].description}`
              : range[0].description
          )
          .join(', ');

    return {
      day_description: dayDescription,
      intervals: intervals.map(({ hourFrom, hourTo }) => `${hourFrom} - ${hourTo}`),
      order: Math.min(...days.map((day) => dayOrder(day.code)))
    };
  });

  return groupedSchedules
    .sort((a, b) => a.order - b.order)
    .map(({ order, ...schedule }) => schedule);
};

module.exports = { groupSchedules };